<template>
  <HeadTitle
    title="Documentos y políticas"
    description="En esta sección podrás encontrar documentación relevante"
  />
  <br />
  <DataTable
    class="tabla mb-5"
    :value="documentFiles"
    paginator
    :rowsPerPageOptions="[5, 10, 20, 50]"
    tableStyle="min-width: 50rem"
    :rows="5"
    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    :totalRecords="documentFiles.length"
    :currentPageReportTemplate="currentPageReportTemplate"
    scrollable
    scrollHeight="600px"
    :loading="isLoading"
  >
    <Column field="name" header="Nombre" style="width: 20%">
      <template #body="{ data }">
        {{ data.name }}
      </template>
    </Column>
    <Column field="type" header="Extensión" style="width: 20%">
      <template #body="{ data }">
        <span v-if="data.type">
          {{ data.type }}
        </span>
        <span v-else>
          <label class="text-600 font-medium">Sin asignar</label>
        </span>
      </template>
    </Column>
    <Column field="size" header="Tamaño(kb)" style="max-width: 5%">
      <template #body="{ data, field }">
        <span class="text-green-800">
          {{ Number(data[field] / 1024).toFixed(2) }}
        </span>
      </template>
    </Column>
    <Column field="file" header="Archivo">
      <template #body="{ data }">
        <Button
          v-if="data.file"
          v-tooltip.bottom="'ver adjunto'"
          class="action-btn view hover:text-blue-800 mr-2"
          severity="primary"
          icon="pi pi-paperclip"
          @click="downloadAttachment(data.file)"
        ></Button>
      </template>
    </Column>
    <Column field="link_1" header="Enlace 1">
      <template #body="{ data }">
        <Button
          v-tooltip.bottom="data.link_1"
          v-if="data.link_1"
          icon="pi pi-external-link"
          class="action-btn view hover:text-blue-800"
          severity="secondary"
          @click="openLink(data.link_1)"
        ></Button>
      </template>
    </Column>
    <Column field="link_2" header="Enlace 2">
      <template #body="{ data }">
        <Button
          v-tooltip.bottom="data.link_2"
          v-if="data.link_2"
          icon="pi pi-external-link"
          class="action-btn view hover:text-blue-800"
          severity="secondary"
          @click="openLink(data.link_2)"
        ></Button>
      </template>
    </Column>
    <Column field="createdAt" header="Fecha de creación">
      <template #body="{ data, field }">
        <span>{{ dayjs(data[field]).format('DD/MM/YYYY hh:mm') }}</span>
      </template>
    </Column>
  </DataTable>
</template>
<script setup lang="ts">
  import DocumentFile from '@/modules/documents/models/DocumentFile'
  import { computed, onMounted, ref } from 'vue'
  import { getDocumentFilesByEmployeeId } from '../services/DocumenFileService'
  import { storeToRefs } from 'pinia'
  import { useUserStore } from '@/store/user'
  import { getFileUrlPresigned } from '@/shared/services/fileService'
  import HeadTitle from '@/shared/components/HeadTitle.vue'
  import dayjs from 'dayjs'

  const { user } = storeToRefs(useUserStore())
  const documentFiles = ref<DocumentFile[]>([])
  const isLoading = ref(false)

  onMounted(async () => {
    isLoading.value = true
    const response = await getDocumentFilesByEmployeeId(
      user.value?.employeeId || ''
    )
    documentFiles.value = response
    isLoading.value = false
  })

  const currentPageReportTemplate = computed(() => {
    return `{first} a {last} de ${documentFiles.value.length}`
  })

  const downloadAttachment = async (file: string | File) => {
    if (typeof file === 'string') {
      const fileUrl = await getFileUrlPresigned(file)
      window.open(fileUrl, '_blank')
    } else {
      const fileUrl = URL.createObjectURL(file)
      window.open(fileUrl, '_blank')
    }
  }

  const openLink = (link: string) => {
    window.open(link, '_blank')
  }
</script>
